<template lang="pug">
#laudos
    SelecionarTerritorio(
        :tipoLaudo='tipoLaudo',
        @getTerritoriosSelecionados='solicitarLaudos',
        @cancelar-modal='changeShowModalSelecionarTerritorio',
        ref='selecionarTerritorio'
    )
</template>

<script>
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';

import LaudoService from '@/modules/laudos/services/LaudosService';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'Laudos',
    components: {
        SelecionarTerritorio
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        ...mapState(['usuarioIsLaudo'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.BACEN_FISCALIZACAO,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            idLaudo: null,
            laudos: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.BACEN_FISCALIZACAO
            },
            showModalInsercaoResultados: false,
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false
        };
    },
    async mounted() {
        if (this.usuarioIsLaudo) {
            this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
        }
        await this.getLaudos();
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.$emit('showModalSelecionarTerritorios');
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(territorio => {
                idsTerritorio += territorio.id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoBacenFiscalizacao',
                params: { idsTerritorio }
            });
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },

        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },

        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
        min-height: 55vh;
        max-height: 72vh;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
